module.exports = __webpack_public_path__ + "static/media/icons-close-black.a67a3ab8.svg";